import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

// Layout Components
import { Navbar } from "./components/layout/Navbar";
import { Footer } from "./components/layout/Footer";

// Public Pages
import { Home } from "./pages/Home";
import { HowItWorks } from "./pages/HowItWorks";
import { Pricing } from "./pages/Pricing";
import { Schools } from "./pages/Schools";
import { Careers } from "./pages/Careers";
import { Contact } from "./pages/Contact";

// Customer account
import Login from "./pages/Login";
import Register from "./pages/Register";
import Account from "./pages/Account";
import MyReservation from "./pages/MyReservation";
import CustomerProtectedRoute from "./components/CustomerProtectedRoute";

// Admin
import AdminLayout from "./components/admin/AdminLayout";
import AdminProtectedRoute from "./components/admin/AdminProtectedRoute";
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import Reservations from "./pages/admin/Reservations";
import ReservationDetails from "./pages/admin/ReservationDetails";
import SchoolsAdmin from "./pages/admin/Schools";
import BranchPerformance from "./pages/admin/BranchPerformance";
import Pickups from "./pages/admin/Pickups";
import Deliveries from "./pages/admin/Deliveries";
import Inventory from "./pages/admin/Inventory";
import Payments from "./pages/admin/Payments";
import Reports from "./pages/admin/Reports";
import Support from "./pages/admin/Support";
import Team from "./pages/admin/Team";
import Settings from "./pages/admin/Settings";

function Shell() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <>
      {!isAdmin && <Navbar />}
      <main className={isAdmin ? '' : 'flex-grow'}>
        <Routes>
          {/* Public */}
          <Route path="/" element={<Home />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/schools" element={<Schools />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reservation/success" element={<Contact />} />

          {/* Customer account */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/account" element={<CustomerProtectedRoute><Account /></CustomerProtectedRoute>} />
          <Route path="/account/reservations/:id" element={<CustomerProtectedRoute><MyReservation /></CustomerProtectedRoute>} />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <AdminProtectedRoute>
                <AdminLayout />
              </AdminProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="reservations" element={<Reservations />} />
            <Route path="reservations/:id" element={<ReservationDetails />} />
            <Route path="schools" element={<SchoolsAdmin />} />
            <Route path="branch-performance" element={<BranchPerformance />} />
            <Route path="pickups" element={<Pickups />} />
            <Route path="deliveries" element={<Deliveries />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="payments" element={<Payments />} />
            <Route path="reports" element={<Reports />} />
            <Route path="support" element={<Support />} />
            <Route path="team" element={<Team />} />
            <Route path="settings" element={<Settings />} />
          </Route>
        </Routes>
      </main>
      {!isAdmin && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
